import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminLeaders = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LEADERS.GET_ALL, { params });
    return response.data;
};
export const getAdminLeaderById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LEADERS.GET_BY_ID(id));
    return response.data;
};
export const createLeader = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.LEADERS.CREATE, data);
    return response.data;
};
export const updateLeader = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.LEADERS.UPDATE(id), data);
    return response.data;
};
export const deleteLeader = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.LEADERS.DELETE(id));
    return response.data;
};

